import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import { BrowserRouter } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import registerServiceWorker from './registerServiceWorker';
//import './style/index.css';
import * as firebase from 'firebase';

/*productionkeys
var config = {
   apiKey: "AIzaSyC4umbQ3Av0bWfRGYMWZe9CJMv6A7Esbc4",
   authDomain: "traderx-a41b3.firebaseapp.com",
   databaseURL: "https://traderx-a41b3.firebaseio.com",
   projectId: "traderx-a41b3",
   storageBucket: "traderx-a41b3.appspot.com",
   messagingSenderId: "64491605877"
};
*/
/*
var config = {
	apiKey: "AIzaSyCtZ4oVZFRCRN2juh4smbUJCoMpszPuYTQ",
	authDomain: "traderxsandbox.firebaseapp.com",
	databaseURL: "https://traderxsandbox.firebaseio.com",
	projectId: "traderxsandbox",
	storageBucket: "traderxsandbox.appspot.com",
	messagingSenderId: "242933715708"
}; //sandbox keys
*/
var config = {
	apiKey: "AIzaSyCXZ51hEfYGA4nt7f0CNK_cDVStMXgZ2og",
	authDomain: "traderexdevelopment.firebaseapp.com",
	databaseURL: "https://traderexdevelopment.firebaseio.com",
	projectId: "traderexdevelopment",
	storageBucket: "traderexdevelopment.appspot.com",
	messagingSenderId: "1096455515344"
}; //dev keys

firebase.initializeApp(config);


var dbs = [
	firebase,
	firebase.initializeApp({
	    apiKey: "AIzaSyCpZW3Wf6pwXaXw_CN4keefpmfDPFiVgtI",
	    authDomain: "traderexdatabase1.firebaseapp.com",
	    databaseURL: "https://traderexdatabase1.firebaseio.com",
	    projectId: "traderexdatabase1",
	    storageBucket: "traderexdatabase1.appspot.com",
	    messagingSenderId: "308276616136",
	    appId: "1:308276616136:web:53f4aaf41fca3a58"
  }, "trxdb1"),
  firebase.initializeApp({
    apiKey: "AIzaSyCWAuylHu8AjWxHrFuE8l_nACmlxMwv2G0",
    authDomain: "traderex-database2.firebaseapp.com",
    databaseURL: "https://traderex-database2.firebaseio.com",
    projectId: "traderex-database2",
    storageBucket: "traderex-database2.appspot.com",
    messagingSenderId: "120063677873",
    appId: "1:120063677873:web:a54f08f44b9b7223"
  }, "trxdb2"),
  firebase.initializeApp({
    apiKey: "AIzaSyAZNl0JpPUTNYjEC2ENYk3G_jia1K3_73w",
    authDomain: "traderexdatabase3.firebaseapp.com",
    databaseURL: "https://traderexdatabase3.firebaseio.com",
    projectId: "traderexdatabase3",
    storageBucket: "traderexdatabase3.appspot.com",
    messagingSenderId: "750793083401",
    appId: "1:750793083401:web:2b9f3e1325a63048"
  }, "trxdb3")
];

ReactDOM.render(
    <BrowserRouter>
        <App dbs={dbs}/>
    </BrowserRouter>
    , document.getElementById('root'));


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js